var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"order-control immerse-control-panel"},[_c('ByButton',{attrs:{"stl":"main2","loading":_vm.loadings[0]},on:{"click":_vm.onBack}},[_vm._v(_vm._s(_vm.names[0]))]),_c('ByButton',{attrs:{"stl":"main1","loading":_vm.loadings[1]},on:{"click":_vm.onNext}},[_vm._v(_vm._s(_vm.names[1]))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }